import { useParams, Navigate } from "@/lib/router-compat";
import { ClusterHub } from "@/components/seo/ClusterHub";
import { clubMatcherFromSlug, slugify, titleCaseFromSlug } from "@/lib/entities";
import { sportsTeamJsonLd } from "@/lib/seoSchema";
import { clubCrumbs } from "@/lib/breadcrumbs";

/**
 * Club entity page. The slug is a slugified team name; predictions whose
 * home/away team contains the club name are matched. Emits SportsTeam +
 * BreadcrumbList JSON-LD via the shared builder so `name`, `@id` and
 * `memberOf` stay consistent with the verifier.
 */
export default function ClubHub() {
  const { slug = "" } = useParams();
  if (!slug) return <Navigate to="/predictions" replace />;

  const readable = titleCaseFromSlug(slug);
  const matcher = clubMatcherFromSlug(slug);

  const title = `${readable} Predictions & Betting Tips | Statlign`;
  const description = `${readable} match predictions, value odds and betting tips backed by recent form and our 50-strategy analysis engine.`;

  const teamSchema = sportsTeamJsonLd({ name: readable });

  return (
    <ClusterHub
      kind="team"
      slug={slugify(readable)}
      matchers={[matcher]}
      heading={`${readable} Predictions`}
      title={title}
      description={description}
      keywords={`${readable} predictions, ${readable} betting tips, ${readable} odds`}
      intro={`Upcoming ${readable} predictions and betting tips, combining recent form, head-to-head trends and our strategy engine to surface the best value across all markets.`}
      canonicalPath={`/clubs/${slugify(readable)}`}
      extraJsonLd={teamSchema}
      breadcrumbs={clubCrumbs(slugify(readable), readable)}
    />
  );
}
